import './ProjectComponent.css';
import Photos from "./Photos"
import Capsule from "./Capsule"

import {Link} from "react-router-dom"

function ProjectComponent(prop) {
  let projects = require("./Resources/projects");
  let project = []
  for (let i = 0; i < projects.projects.length; i++) {
    if (projects.projects[i].link === prop.link) {
        project = projects.projects[i]
        break
    }
  }

 return (
    <div className="ProjectComponent">
            <div className="flex-container">
                <div className="scrollPane">

                    <h1>{project.name}</h1>
                    <hr/>
                    <p>When: {project.date}</p>
                    <hr/>
                    <h5>
                    Description:
                    </h5>
                    <p>{project.desc}</p>
                    <h5>
                    <hr/>
                    Technologies/Skills
                    </h5>
                    {project.technologies.map((item) => (
                        <Capsule value={item}/>
                    ))}
                    {project.github !== "" ? (<>
                    <hr/>
                    <a href={project.github} target="_blank" rel="noreferrer" style={{display: "flex",alignItems: "center"}}><img style={{width: "1.5em", height: "1.5em", borderRadius: "5px", marginRight: "5px"}} alt="github" src={require("./Resources/githubLogo.png")} /><h5 style={{margin: "0%"}}>GitHub</h5></a>

                    </> ) : ( <> </>)}
                    {project.play !== "" ? (<>
                    <hr/>
                    <Link to={"/" + project.play} style={{display: "flex",alignItems: "center"}}><img style={{width: "1.5em", height: "1.5em", borderRadius: "5px", marginRight: "5px"}} alt="Play" src={require("./Resources/playButton.png")} /><h5 style={{margin: "0%"}}>Play Here</h5></Link>

                    </> ) : ( <> </>)}


                </div>
                <div className="carouselWrapper">
                    <Photos key={project.name + "Image"} photosArr={project.media}/>
                </div>

            </div>
    </div>
 );
 }

export default ProjectComponent;
